<div class="root container my-4">
  <div class="row">
    <div class="col-12 col-md-6 container">
      <div class="row align-items-center">
        <h2 i18n class="col-6 font-weight-bolder">Sign in</h2>
      </div>
      <div class="row">
        <div class="col-12 my-3">
          <button
            i18n
            class="w-100 btn btn-lg btn-uppercase-lg btn-primary-custom-mobile"
            routerLink="/{{ LoginViaPhone }}"
          >
            SIGN IN WITH MOBILE
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 my-3">
          <button
            i18n
            class="w-100 btn btn-lg btn-uppercase-lg btn-primary-custom-email"
            routerLink="/{{ LoginViaEmail }}"
          >
            SIGN IN WITH EMAIL
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 my-3">
          <label i18n class="font-size-smaller"
            >Don't have an account yet? Create one by clicking the button below.</label
          >
          <button
            i18n
            class="w-100 btn btn-lg btn-uppercase-lg btn-primary-custom-email"
            routerLink="/{{ RegistrationRoute }}"
          >
            Create an account
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
